<template>
  <NodeFolderAvatar
    v-if="node?.type && isNodeTypeFolder(node.type)"
    image="/svg/illustrations/folder-selected.svg"
    size="180"
  />
  <v-img
    v-else-if="nodeThumbnailUrl"
    :height="height"
    :max-height="maxHeight"
    :max-width="maxWidth"
    :min-height="minHeight"
    :min-width="minWidth"
    :src="nodeThumbnailUrl"
    :width="width"
  >
    <template #placeholder>
      <v-row class="fill-height ma-0 align-center justify-center">
        <v-progress-circular color="primary-lighten-5" indeterminate />
      </v-row>
    </template>
  </v-img>

  <NodeIcon
    v-else
    height="150"
    :mime-type="node.mimeType"
    :name="node.name"
    :type="node.type"
    width="100%"
  />
</template>

<script lang="ts" setup>
import { isNodeTypeFolder } from '@deepcloud/deep-ui-utils'
import NodeFolderAvatar from '@/components/node/NodeFolderAvatar.vue'
import NodeIcon from '@/components/node/NodeIcon.vue'
import type { DisplayItem } from '@/components/box/details-drawer/BoxDetailsDrawer.vue'

const props = defineProps({
  node: {
    type: Object as PropType<DisplayItem>,
    default: () => ({}),
  },
  height: {
    type: [Number, String],
    default: 180,
  },
  maxHeight: {
    type: [Number, String],
    default: null,
  },
  minHeight: {
    type: [Number, String],
    default: null,
  },
  width: {
    type: [Number, String],
    default: null,
  },
  maxWidth: {
    type: [Number, String],
    default: null,
  },
  minWidth: {
    type: [Number, String],
    default: null,
  },
})

const nodeThumbnailUrl = computed(() => props.node.thumbnailUrl || null)
</script>
